import keyCodes from '../../constants/vd-key-codes'

/**
 * Service that provides a FILO stack of Escape actions ensuring only the most recently registered action is executed
 * when the Escape key is pressed.
 *
 * @class EscapeStackService
 */
export default class EscapeStackService {
  constructor($document) {
    'ngInject'

    this._$document = $document
    this._handler = e => {
      if (e.which === keyCodes.ESC && this._escapeActionStack.length) {
        this._escapeActionStack[this._escapeActionStack.length - 1]()
      }
    }

    this._escapeActionStack = []
  }

  /**
   * Register a shortcut to perform the given action when the Escape key is pressed. Stacks shortcuts in a FILO queue
   * to ensure that if we have multiple escape-to-close things open they only close one at a time in the reverse order
   * they were opened.
   *
   * @method register
   *
   * @param  {Function} action
   *         The action to perform when the Escape key is pressed
   */
  register(action) {
    this._escapeActionStack.push(action)

    if (this._escapeActionStack.length === 1) {
      this._$document.on('keydown', this._handler)
    }
  }

  /**
   * Deregister the given action from the stack of actions to perform when the Escape key is pressed.
   *
   * @method deregister
   *
   * @param  {Function} action
   *         The action that was to be performed when the Escape key was pressed but should now be deregistered
   */
  deregister(action) {
    const indexOfAction = this._escapeActionStack.indexOf(action)
    if (indexOfAction > -1) {
      this._escapeActionStack.splice(indexOfAction, 1)
    }

    if (this._escapeActionStack.length === 0) {
      this._$document.off('keydown', this._handler)
    }
  }
}
